var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPathologistSidebarIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.512,
    height: 17.236,
    viewBox: "0 0 16.512 17.236",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "svgviewer-output",
    transform: "translate(-1.659 -1.155)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_65329",
    "data-name": "Path 65329",
    d: "M28.047,45.082l-4-2.312.4-.686,4,2.311Z",
    transform: "translate(-16.215 -29.65)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65330",
    "data-name": "Path 65330",
    d: "M33.444,19.649a5.956,5.956,0,0,0-.942-9.423l1.93-3.343-.3-.176.478-.827L33.359,5.16l-.477.826-.32-.184-4.747,8.223.416.24-.589,1.019,1.042.6.589-1.018.414.24,2-3.458a4.34,4.34,0,0,1-2.331,8h-3.5v1.643H35.7V19.649H33.444Z",
    transform: "translate(-17.527 -2.901)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65331",
    "data-name": "Path 65331",
    d: "M5.685,1.155A4.026,4.026,0,1,0,9.71,5.18,4.031,4.031,0,0,0,5.685,1.155Zm0,7.679A3.653,3.653,0,1,1,9.338,5.18,3.658,3.658,0,0,1,5.685,8.834Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65332",
    "data-name": "Path 65332",
    d: "M8.707,12.741H9.48v-.784H8.707Z",
    transform: "translate(-5.106 -7.826)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65333",
    "data-name": "Path 65333",
    d: "M7.952,4.27a3.169,3.169,0,1,0,3.167,3.17A3.173,3.173,0,0,0,7.952,4.27ZM5.592,7.447V6.114H6.916V7.447ZM6.956,9.885a.657.657,0,1,1,.656-.656A.657.657,0,0,1,6.956,9.885ZM7.75,8.427a.657.657,0,1,1,.657-.657A.657.657,0,0,1,7.75,8.427ZM8.21,5.94a.692.692,0,1,1,.672-.692A.692.692,0,0,1,8.21,5.94ZM9.357,9.462a.657.657,0,1,1,.656-.657.657.657,0,0,1-.656.657ZM9.5,7.532a.657.657,0,1,1,.657-.656A.657.657,0,0,1,9.5,7.532Z",
    transform: "translate(-2.263 -2.257)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPathologistSidebarIcon);
export default __webpack_public_path__ + "static/media/pathologist-sidebar-icon.224c738d1386d0877c931c353fee7ea1.svg";
export { ForwardRef as ReactComponent };